export enum EvalueringsstatistikTabEnum {
    Uddannelsessteder = 1,
    Evalueringer = 2,
    Kommentarer = 3
}
